export const DISALLOWED_SKILL_FILE_EXTENSIONS: readonly string[] = [
  ".doc",
  ".docx",
  ".dot",
  ".dotx",
  ".xls",
  ".xlsx",
  ".xlsm",
  ".xlsb",
  ".ppt",
  ".pptx",
  ".pps",
  ".ppsx",
  ".odt",
  ".ods",
  ".odp",
  ".pages",
  ".numbers",
  ".key",
  ".rtf",
  ".zip",
  ".tar",
  ".gz",
  ".tgz",
  ".bz2",
  ".xz",
  ".rar",
  ".7z",
  ".exe",
  ".dll",
  ".so",
  ".dylib",
  ".dmg",
  ".pkg",
  ".app",
  ".msi",
  ".deb",
  ".rpm",
  ".jar",
  ".war",
  ".bin",
];

const toLowerExtension = (path: string): string => {
  const lastSlash = Math.max(path.lastIndexOf("/"), path.lastIndexOf("\\"));
  const basename = lastSlash >= 0 ? path.slice(lastSlash + 1) : path;
  const dot = basename.lastIndexOf(".");
  if (dot < 0) {
    return "";
  }
  if (dot === 0) {
    return basename.toLowerCase();
  }
  return basename.slice(dot).toLowerCase();
};

export const isDisallowedSkillFilePath = (path: string): boolean => {
  const extension = toLowerExtension(path);
  return (
    Boolean(extension) && DISALLOWED_SKILL_FILE_EXTENSIONS.includes(extension)
  );
};

export const getDisallowedSkillFileReason = (path: string): string | null => {
  const extension = toLowerExtension(path);
  if (!extension || !DISALLOWED_SKILL_FILE_EXTENSIONS.includes(extension)) {
    return null;
  }
  return `Files of type ${extension} are not supported. Office documents, archives, and executables cannot be added to a skill collection.`;
};

const EXT_TO_MONACO_LANGUAGE: Record<string, string> = {
  md: "markdown",
  json: "json",
  sh: "shell",
  py: "python",
  ts: "typescript",
  js: "javascript",
  yaml: "yaml",
  yml: "yaml",
  toml: "toml",
  env: "env",
  conf: "conf",
  config: "config",
};

export const getLanguageForPath = (path: string): string => {
  const ext = path.split(".").pop()?.toLowerCase() ?? "";
  return EXT_TO_MONACO_LANGUAGE[ext] ?? "plaintext";
};
